import DOMPurify from 'dompurify'

/**
 * Study opt-in text (disclaimer, privacy note, region description) is authored
 * in the dashboard and rendered as HTML so that studies can use basic
 * formatting and links. It reaches participants, so it is sanitised first.
 *
 * Writing that text is already restricted to administrators
 * (`POST /api/projects/update`, requireAdmin), so this is not a route an
 * ordinary participant can reach. It closes the case where an administrator
 * account is compromised or a study author pastes markup from elsewhere:
 * without this, script in that field would run for every participant who
 * opens the study.
 *
 * The allow list is deliberately the formatting studies actually use. Anything
 * outside it is stripped, not escaped, so existing text renders exactly as it
 * did before; only script, event handlers and javascript: URLs disappear.
 */
const ALLOWED_TAGS = [
  'a',
  'b',
  'br',
  'div',
  'em',
  'i',
  'li',
  'ol',
  'p',
  'span',
  'strong',
  'u',
  'ul',
  'h1',
  'h2',
  'h3',
  'h4',
]

const ALLOWED_ATTR = ['href', 'target', 'rel', 'style', 'class']

export function sanitizeHtml(value) {
  if (value === null || value === undefined) return ''
  return DOMPurify.sanitize(String(value), {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    // javascript: and data: URIs never survive, whatever the tag
    ALLOWED_URI_REGEXP: /^(?:https?:|mailto:|tel:|#|\/)/i,
  })
}

/** Convenience for the `dangerouslySetInnerHTML` prop shape. */
export function safeHtml(value) {
  return { __html: sanitizeHtml(value) }
}

export default sanitizeHtml
